import React from "react";
import { get } from "../../api/axios";
import { postV2, patchV2, delV2, getV2 } from "../../api/axiosV2";
import {
  Container,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Divider,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Row, Col } from "react-bootstrap";
import Loader from "../../Loader";
import { openAlert } from "simple-react-alert";
import { withRouter } from "react-router-dom";
import "./bonificaciones-style.css";

const AgregarBonificacion = (props) => {
  const [ciudades, setCiudades] = React.useState([]);
  const [negocios, setNegocios] = React.useState([]);
  const [negocioId, setNegocioId] = React.useState(null);
  const [ciudadId, setCiudadId] = React.useState(null);
  const [es_porcentaje, setEsPorcentaje] = React.useState(false);
  const [descuento, setDescuento] = React.useState(0);
  const [campo, setCampo] = React.useState("total");
  const [razon, setRazon] = React.useState("");
  const [disclaimer, setDisclaimer] = React.useState("");
  const [a_cargo_de, setACargoDe] = React.useState("FASTER");
  const [success_title, setSuccessTitle] = React.useState("");
  const [success_description, setSuccessDescription] = React.useState("");
  const [reject_title, setRejectTitle] = React.useState("");
  const [reject_description, setRejectDescription] = React.useState("");
  const [activo, setActivo] = React.useState(true);
  const [minimo_compra, setMinimoCompra] = React.useState(0);
  const [maximo_pedidos, setMaximoPedidos] = React.useState(null);
  const [loader, setLoader] = React.useState(false);
  const [initialLoader, setInitialLoader] = React.useState(true);
  const [isEditing, setIsEditing] = React.useState(false);

  // Load ciudades on mount
  React.useEffect(() => {
    if (!props.editar) {
      setInitialLoader(true);
      get("/ciudades")
        .then((ciudadesResponse) => {
          setCiudades(ciudadesResponse.data);
          setInitialLoader(false);
        })
        .catch((error) => {
          console.error("Error loading ciudades:", error);
          setInitialLoader(false);
        });
    }
  }, [props.editar]);

  // Load negocios when ciudadId changes
  React.useEffect(() => {
    if (ciudadId && ciudadId.id) {
      getV2("/admin/negocios/list?ciudad_id=" + ciudadId.id)
        .then((negociosResponse) => {
          setNegocios(negociosResponse.data);
        })
        .catch((error) => {
          console.error("Error loading negocios:", error);
          setNegocios([]);
        });
    } else {
      setNegocios([]);
    }
  }, [ciudadId]);

  // Load bonificacion data when editing
  React.useEffect(() => {
    if (props.editar && props.match.params.id) {
      setIsEditing(true);
      setInitialLoader(true);
      Promise.all([get("/ciudades"), getV2("/admin/bonificaciones/" + props.match.params.id)])
        .then(([ciudadesResponse, bonificacionResponse]) => {
          setCiudades(ciudadesResponse.data);
          const data = bonificacionResponse.data;

          setMinimoCompra(data.minimo_compra || "");
          setMaximoPedidos(data.maximo_pedidos || null);
          setEsPorcentaje(data.es_porcentaje || false);
          setDescuento(data.descuento || 0);
          setCampo(data.campo || "total");
          setRazon(data.razon || "");
          setDisclaimer(data.disclaimer || "");
          setACargoDe(data.a_cargo_de || "FASTER");
          setSuccessTitle(data.success_title || "");
          setSuccessDescription(data.success_description || "");
          setRejectTitle(data.reject_title || "");
          setRejectDescription(data.reject_description || "");
          setActivo(data.activo !== undefined ? data.activo : true);

          // Handle ciudad first
          let ciudadIdToUse = null;
          if (data.ciudad && data.ciudad.id) {
            let ciudad = ciudadesResponse.data.find((c) => c.id === data.ciudad.id);
            if (!ciudad) {
              const updatedCiudades = [...ciudadesResponse.data, data.ciudad];
              setCiudades(updatedCiudades);
              ciudad = data.ciudad;
            }
            setCiudadId(ciudad);
            ciudadIdToUse = data.ciudad.id;
          } else if (data.ciudad_id) {
            const ciudad = ciudadesResponse.data.find((c) => c.id === data.ciudad_id);
            if (ciudad) {
              setCiudadId(ciudad);
              ciudadIdToUse = data.ciudad_id;
            }
          }

          // Load negocios for this ciudad and then set the negocio
          if (ciudadIdToUse) {
            getV2("/admin/negocios/list?ciudad_id=" + ciudadIdToUse)
              .then((negociosResponse) => {
                setNegocios(negociosResponse.data);
                // Then handle negocio - it needs to be an object, not just an ID
                if (data.negocio && data.negocio.id) {
                  // If negocio object is returned, find it in the list or add it if not present
                  let negocio = negociosResponse.data.find((n) => n.id === data.negocio.id);
                  if (!negocio) {
                    const updatedNegocios = [...negociosResponse.data, data.negocio];
                    setNegocios(updatedNegocios);
                    negocio = data.negocio;
                  }
                  setNegocioId(negocio);
                } else if (data.negocio_id) {
                  // If only negocio_id is returned, find it in the list
                  const negocio = negociosResponse.data.find((n) => n.id === data.negocio_id);
                  if (negocio) {
                    setNegocioId(negocio);
                  } else {
                    console.warn("Negocio not found in list for negocio_id:", data.negocio_id);
                  }
                }
                setInitialLoader(false);
              })
              .catch((error) => {
                console.error("Error loading negocios:", error);
                setInitialLoader(false);
              });
          } else {
            setInitialLoader(false);
          }
        })
        .catch((error) => {
          console.error("Error loading bonificacion:", error);
          setInitialLoader(false);
          openAlert({
            message: "Error al cargar la bonificación",
            type: "danger",
          });
        });
    }
  }, [props.editar, props.match.params.id]);

  const eliminarBonificacion = () => {
    if (!window.confirm("¿Está seguro que desea eliminar esta bonificación?")) {
      return;
    }

    setLoader(true);
    delV2("/admin/bonificaciones/", props.match.params.id)
      .then((res) => {
        setLoader(false);
        openAlert({
          message: "Bonificación eliminada con éxito",
          type: "success",
        });
        props.history.goBack();
      })
      .catch(() => {
        setLoader(false);
        openAlert({
          message: "Error al eliminar bonificación",
          type: "danger",
        });
      });
  };

  const handleSubmit = () => {
    // Validate that ciudad is selected (negocio is optional but only if ciudad is selected)
    if (!ciudadId) {
      openAlert({
        message: "Debe seleccionar una ciudad",
        type: "danger",
      });
      return;
    }

    setLoader(true);

    const body = {
      minimo_compra: parseFloat(minimo_compra) || 0,
      maximo_pedidos: maximo_pedidos ? parseInt(maximo_pedidos) : null,
      es_porcentaje: es_porcentaje,
      descuento: parseFloat(descuento) || 0,
      campo: campo,
      razon: razon,
      disclaimer: disclaimer || null,
      a_cargo_de: a_cargo_de || "FASTER",
      success_title: success_title || null,
      success_description: success_description || null,
      reject_title: reject_title || null,
      reject_description: reject_description || null,
      negocio_id: negocioId ? negocioId.id : null,
      ciudad_id: ciudadId ? ciudadId.id : null,
      activo: activo,
    };

    if (isEditing) {
      // For PATCH, send all fields
      const patchBody = {
        minimo_compra: parseFloat(minimo_compra) || 0,
        maximo_pedidos: maximo_pedidos ? parseInt(maximo_pedidos) : null,
        es_porcentaje: es_porcentaje,
        descuento: parseFloat(descuento) || 0,
        campo: campo,
        razon: razon,
        disclaimer: disclaimer || null,
        a_cargo_de: a_cargo_de || "FASTER",
        success_title: success_title || null,
        success_description: success_description || null,
        reject_title: reject_title || null,
        reject_description: reject_description || null,
        negocio_id: negocioId ? negocioId.id : null,
        ciudad_id: ciudadId ? ciudadId.id : null,
        activo: activo,
      };
      patchV2("/admin/bonificaciones/" + props.match.params.id, patchBody)
        .then((res) => {
          setLoader(false);
          openAlert({
            message: "Bonificación actualizada con éxito",
            type: "success",
          });
          props.history.goBack();
        })
        .catch((error) => {
          setLoader(false);
          openAlert({
            message: "Error al actualizar bonificación",
            type: "danger",
          });
        });
    } else {
      postV2("/admin/bonificaciones", body)
        .then((response) => {
          setLoader(false);
          openAlert({
            message: "Bonificación creada con éxito",
            type: "success",
          });
          props.history.goBack();
        })
        .catch(() => {
          setLoader(false);
          openAlert({
            message: "Error al crear bonificación",
            type: "danger",
          });
        });
    }
  };

  if (initialLoader) {
    return (
      <Container className="container">
        <Row>
          <Col xs={{ span: 8, offset: 2 }} style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
            <Loader />
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="container">
      <ValidatorForm onSubmit={handleSubmit}>
        <Row>
          <Col xs={{ span: 8, offset: 2 }}>
            <Row>
              {/* Primera sección: Bonificación */}
              <Col xs={12} className="mb-3">
                <Typography variant="h6" style={{ marginBottom: "1rem", marginTop: "1rem" }}>
                  Bonificación
                </Typography>
                <Divider style={{ marginBottom: "1rem" }} />
              </Col>
              <Col xs={12} className="mb-2">
                <TextValidator
                  label="Razón"
                  placeholder="Descuento por..."
                  value={razon}
                  onChange={(e) => setRazon(e.target.value)}
                  validators={["required"]}
                  errorMessages={["Este campo es requerido"]}
                  variant="filled"
                  className="textInput"
                  fullWidth
                />
              </Col>
              <Col xs={12} className="mb-2">
                <TextField
                  label="Disclaimer"
                  placeholder="50% en compras mayores a $14000"
                  value={disclaimer}
                  onChange={(e) => setDisclaimer(e.target.value)}
                  variant="filled"
                  className="textInput"
                  fullWidth
                  multiline
                  rows={2}
                />
              </Col>
              <Col xs={6} className="mb-2">
                <TextValidator
                  label="Descuento"
                  placeholder="0"
                  value={descuento}
                  onChange={(e) => setDescuento(e.target.value)}
                  validators={["required", "isNumber", "minNumber:0"]}
                  errorMessages={[
                    "Este campo es requerido",
                    "Debe ser un número",
                    "Debe ser mayor o igual a 0",
                  ]}
                  variant="filled"
                  className="textInput"
                  type="number"
                  step={es_porcentaje ? "0.01" : "1"}
                />
              </Col>
              <Col xs={6} className="mb-2">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={es_porcentaje}
                      onChange={(e) => setEsPorcentaje(e.target.checked)}
                      value="es_porcentaje"
                    />
                  }
                  label="Es porcentaje"
                />
              </Col>
              <Col xs={6} className="mb-2">
                <FormControl variant="filled" className="textInput" fullWidth>
                  <InputLabel>Campo</InputLabel>
                  <Select value={campo} onChange={(e) => setCampo(e.target.value)}>
                    <MenuItem value="total">Total</MenuItem>
                    <MenuItem value="precio_envio">Precio Envío</MenuItem>
                  </Select>
                </FormControl>
              </Col>
              <Col xs={6} className="mb-2">
                <FormControl variant="filled" className="textInput" fullWidth>
                  <InputLabel>A cargo de</InputLabel>
                  <Select value={a_cargo_de} onChange={(e) => setACargoDe(e.target.value)}>
                    <MenuItem value="FASTER">Faster</MenuItem>
                    <MenuItem value="NEGOCIO">Negocio</MenuItem>
                    <MenuItem value="AMBOS">Ambos</MenuItem>
                  </Select>
                </FormControl>
              </Col>
              <Col xs={6} className="mb-2">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={activo}
                      onChange={(e) => setActivo(e.target.checked)}
                      value="activo"
                    />
                  }
                  label="Activo"
                />
              </Col>

              {/* Segunda sección: Condiciones */}
              <Col xs={12} className="mb-3" style={{ marginTop: "1rem" }}>
                <Typography variant="h6" style={{ marginBottom: "1rem", marginTop: "1rem" }}>
                  Condiciones
                </Typography>
                <Divider style={{ marginBottom: "1rem" }} />
              </Col>
              <Col xs={12} className="mb-2">
                <Autocomplete
                  id="ciudad-autocomplete"
                  variant="filled"
                  onChange={(e, v) => {
                    setCiudadId(v);
                    setNegocioId(null); // Clear negocio when ciudad changes
                  }}
                  options={ciudades}
                  getOptionLabel={(option) => option.nombre || ""}
                  value={ciudadId}
                  getOptionSelected={(option, value) => option && value && option.id === value.id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="filled"
                      label="Ciudad"
                      required
                      helperText={!ciudadId ? "Debe seleccionar una ciudad" : ""}
                    />
                  )}
                />
              </Col>
              <Col xs={12} className="mb-2">
                <Autocomplete
                  id="negocio-autocomplete"
                  variant="filled"
                  disabled={!ciudadId}
                  onChange={(e, v) => {
                    setNegocioId(v);
                  }}
                  options={negocios}
                  getOptionLabel={(option) => option.nombre || ""}
                  value={negocioId}
                  getOptionSelected={(option, value) => option && value && option.id === value.id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="filled"
                      label="Negocio"
                      helperText={!ciudadId ? "Primero debe seleccionar una ciudad" : "Opcional"}
                    />
                  )}
                />
              </Col>
              <Col xs={6} className="mb-2">
                <TextValidator
                  label="Minimo Compra"
                  placeholder="0"
                  value={minimo_compra}
                  onChange={(e) => setMinimoCompra(e.target.value)}
                  validators={["required", "isNumber", "minNumber:0"]}
                  errorMessages={[
                    "Este campo es requerido",
                    "Debe ser un número",
                    "Debe ser mayor a 0",
                  ]}
                  variant="filled"
                  className="textInput"
                  type="number"
                />
              </Col>
              <Col xs={6} className="mb-2">
                <TextField
                  label="Maximo Pedidos"
                  placeholder="Opcional"
                  value={maximo_pedidos || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setMaximoPedidos(value === "" ? null : parseInt(value));
                  }}
                  variant="filled"
                  className="textInput"
                  type="number"
                  inputProps={{ min: 0 }}
                />
              </Col>

              {/* Tercera sección: Modal de que el usuario aplica al beneficio */}
              <Col xs={12} className="mb-3" style={{ marginTop: "1rem" }}>
                <Typography variant="h6" style={{ marginBottom: "1rem", marginTop: "1rem" }}>
                  Modal de que el usuario aplica al beneficio
                </Typography>
                <Divider style={{ marginBottom: "1rem" }} />
              </Col>
              <Col xs={12} className="mb-2">
                <TextValidator
                  label="Título"
                  placeholder="¡Bonificación aplicada!"
                  value={success_title}
                  onChange={(e) => setSuccessTitle(e.target.value)}
                  variant="filled"
                  className="textInput"
                  fullWidth
                />
              </Col>
              <Col xs={12} className="mb-2">
                <TextValidator
                  label="Mensaje"
                  placeholder="Tu bonificación ha sido aplicada correctamente"
                  value={success_description}
                  onChange={(e) => setSuccessDescription(e.target.value)}
                  variant="filled"
                  className="textInput"
                  fullWidth
                  multiline
                  rows={3}
                />
              </Col>

              {/* Cuarta sección: Mensaje de que no aplica */}
              <Col xs={12} className="mb-3" style={{ marginTop: "1rem" }}>
                <Typography variant="h6" style={{ marginBottom: "1rem", marginTop: "1rem" }}>
                  Mensaje de que no aplica
                </Typography>
                <Divider style={{ marginBottom: "1rem" }} />
              </Col>
              <Col xs={12} className="mb-2">
                <TextValidator
                  label="Motivo de rechazo"
                  placeholder="Debes cumplir el minimo de compra de $40000"
                  value={reject_description}
                  onChange={(e) => setRejectDescription(e.target.value)}
                  variant="filled"
                  className="textInput"
                  fullWidth
                  multiline
                  rows={3}
                />
              </Col>
              <Col xs={12}>
                <div className="form-card-header">
                  <div className="buttons-header">
                    <Button
                      size="large"
                      variant="contained"
                      className=""
                      onClick={() => props.history.goBack()}
                    >
                      Volver
                    </Button>
                    {loader ? (
                      <Loader />
                    ) : (
                      <>
                        <Button size="large" variant="contained" type="submit" className="ml-2">
                          Guardar
                        </Button>
                        {isEditing && (
                          <Button
                            size="large"
                            variant="contained"
                            color="secondary"
                            className="ml-2"
                            onClick={() => eliminarBonificacion()}
                          >
                            Eliminar
                          </Button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </ValidatorForm>
    </Container>
  );
};

export default withRouter(AgregarBonificacion);
